import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';

import {FriendsService} from '../../../services/friends.service';
import {BaseUserViewModel, UserFriendViewModel} from '../../../viewModels/userFriend.viewModel';
import {UsersService} from '../../../services/users.service';
import {Router} from '@angular/router';
import {LocalisationService} from '../../../services/localisation.service';
import {unauthenticatedEntryRoute} from '../../../config/agaia-web-access.config';

@Component({
    selector: 'app-delete-section',
    templateUrl: './delete-section.component.html',
    styleUrls: ['./delete-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteSectionComponent implements OnInit {

    constructor(
        public readonly router: Router,
        private readonly usersService: UsersService,
        private readonly localisationService: LocalisationService
    ) {
    }

    ngOnInit() {
    }

    deleteAccount() {
        if (confirm(this.localisationService.localise('delete_user_account_confirm'))) {
            this.usersService.deleteUserAccount().subscribe(() => {
                this.router.navigate([unauthenticatedEntryRoute()]);
            });
        }
    }

    onWebChat() {
        document.body.classList.remove('hide-tidio-chat');
        window['tidioChatApi'].open();

        document.addEventListener('tidioChat-close', function () {
            document.body.classList.add('hide-tidio-chat');
        });
    }

}
